module.exports = __webpack_public_path__ + "img/img-related04.f9785613.jpg";